import '.c8{position:absolute;}.ssr-plugin'
import '.c9{top:calc(100%);}.ssr-plugin'
/* eslint-disable react-refresh/only-export-components */
import { useState, Children, type PropsWithChildren } from 'react'
import { styled, type Style } from 'inlines'
import { Text } from '../typography/Text'
import { LinkWrapper } from '../link/LinkWrapper'

const Group = ({ children }: PropsWithChildren) => {
  return (
    <div
      style={{
        justifyContent: 'flex-start',
        alignItems: 'center',
        display: 'inline-flex',
      }}
    >
      {Children.map(children, (child) => child)}
    </div>
  )
}

export type TabProps = {
  children?: JSX.Element
  label: string
  to?: string
  active?: boolean
}

const Tab = ({ children, label, to, active }: TabProps) => {
  const [subMenuShown, setSubMenuShown] = useState(false)
  const tabStyle: Style = {
    padding: 24,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    display: 'flex',
    cursor: to ? 'pointer' : 'default',
    borderBottom: active
      ? 'var(--nav-item-border-active)'
      : 'var(--nav-item-border-inactive)',
    userSelect: 'none',
    '&:hover': { borderBottom: 'var(--nav-item-border-active)' },
  }

  const textStyle: Style = {
    wordWrap: 'break-word',
    color: 'var(--brand-secondary)',
    '&:hover': {
      color: 'var(--brand-secondary)',
    },
    fontWeight: active ? 'bold' : 'normal',
  }

  const subMenu =
    children && subMenuShown ? (
      <div className="c8 c9">
        {children}
      </div>
    ) : null

  const body = (
    <styled.div
      style={tabStyle}
      onMouseOver={() => setSubMenuShown(true)}
      onMouseOut={() => setSubMenuShown(false)}
    >
      <Text.Medium style={textStyle}>{label}</Text.Medium>
      {subMenu}
    </styled.div>
  )

  if (!to) return body

  if (to.startsWith('#')) {
    return (
      <a href={to} style={{ textDecoration: 'none' }}>
        {body}
      </a>
    )
  }

  return <LinkWrapper to={to}>{body}</LinkWrapper>
}

export const HoverTabs = {
  Group,
  Tab,
}
